export default __webpack_public_path__ + "static/media/598.ca638767.jpg";